import catalogResponse from "transformers/catalogResponse";
import apiRequest from "./apiRequest";

export const getFarms = async (query, token) => {
  const farms = await apiRequest.get(`v2/farms?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return farms.data;
};

export const getFields = async (farmId, token) => {
  const fields = await apiRequest.get(`v2/farms/${farmId}/fields`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return fields.data;
};

export const createFarm = async (params, token) => {
  const farm = await apiRequest.post("v2/farms", params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return farm.data;
};

export const deleteFarm = async (farmId, token) => {
  const farm = await apiRequest.delete(`v2/farms/${farmId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return farm.status;
};

export const getFarm = async (farmId, token) => {
  const farm = await apiRequest.get(`v2/farms/${farmId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return farm.data;
};

export const createField = async (farmId, params, token) => {
  const field = await apiRequest.post(`v2/farms/${farmId}/fields`, params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return field.data;
};

export const shareFarm = async (data, token) => {
  const response = await apiRequest.post("v2/farms/share_farm", data, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response;
};

export const convertFile = async (files, token) => {
  const response = apiRequest.post("v2/convert", files, {
    headers: {
      authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
      accept: "application/json",
    },
  });

  return response;
};

export const getCatalog = async (query, token) => {
  // Remove this if api is ready to support rapid_em
  if (query.includes("rapid_em")) {
    return [
      {
        date: "Oct 01 to Oct 07",
        items: [
          {
            source: "rapid_em",
            algorithm: "SHALLOW",
            statistics_url:
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/statistics.json?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            tile_urls: [
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/tiles/{z}/{x}/{y}.webp?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            ],
          },
        ],
      },
      {
        date: "Oct 08 to Oct 14",
        items: [
          {
            source: "rapid_em",
            algorithm: "SHALLOW",
            statistics_url:
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/statistics.json?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            tile_urls: [
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/tiles/{z}/{x}/{y}.webp?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            ],
          },
        ],
      },
      {
        date: "Oct 15 to Oct 21",
        items: [
          {
            source: "rapid_em",
            algorithm: "SHALLOW",
            statistics_url:
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/statistics.json?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            tile_urls: [
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/tiles/{z}/{x}/{y}.webp?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            ],
          },
        ],
      },
      {
        date: "Oct 22 to Oct 28",
        items: [
          {
            source: "rapid_em",
            algorithm: "SHALLOW",
            statistics_url:
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/statistics.json?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            tile_urls: [
              "https://api.test.datafarming.com/v2/algorithm/standard_ndvi/tiles/{z}/{x}/{y}.webp?field_ids=241349&latest_capture_date=2022-10-26&color_stretch=dynamic",
            ],
          },
        ],
      },
    ];
  }

  const catalog = await apiRequest.get(`v2/catalog?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    transformResponse: (data) => catalogResponse(JSON.parse(data)),
  });

  return catalog.data;
};

export const updateFarm = async (farmId, params, token) => {
  const farm = await apiRequest.put(`v2/farms/${farmId}`, params, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return farm.data;
};

export const deleteCollaborator = async (data, token) => {
  const { farmId, email } = data;
  const response = await apiRequest.post(
    `v2/farms/${farmId}/remove_collaborator/${email}`,
    data,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );

  return response;
};
